export default __webpack_public_path__ + "static/media/uikit-image.127673cd.svg";